import { createDynamicSlice } from ".";
import { getDesignationListThunk } from "../thunks/designationsThunk";

export const designationsSlice = createDynamicSlice({
  name: "designations",
  thunk: getDesignationListThunk,
  listMode: true,
  resetActionName: "resetDesignations",
});

export const designationsReducer = designationsSlice.reducer;
export const { resetDesignations } = designationsSlice.actions;
